import React from "react";

export default function Marquee({ items = [], speed = "marquee", className = "" }) {
  const doubled = [...items, ...items];
  return (
    <div className={`mq-mask overflow-hidden ${className}`}>
      <div className={`flex items-center gap-16 whitespace-nowrap ${speed}`}>
        {doubled.map((item, i) => (
          <div key={i} className="flex items-center gap-16 shrink-0">
            {item}
          </div>
        ))}
      </div>
    </div>
  );
}
